"use strict";

/**
 * @classdesc
 * Zoomt die Karte auf die Ausdehnung der aktuell ausgewählten Layer.
 *
 * @class
 * @extends gc.gis.action.GCAbstractAction
 * @memberof gc.gis.action.layer
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen
 * @param {gc.gis.map.GCMapView} options.map Referenz auf die Karte
 */
gc.gis.action.layer.ZoomToSelection = function( options )
{
	gc.gis.action.GCAbstractAction.call( this );

	this.func = this.doExecute;
	this.args = [options.map];
};
gc.gis.action.layer.ZoomToSelection.prototype = Object.create( gc.gis.action.GCAbstractAction.prototype );

/**
 * Zoomt die Karte auf die Ausdehnung der aktuell ausgewählten Layer.
 *
 * @param {gc.gis.map.GCMapView} map Referenz auf die Karte
 */
gc.gis.action.layer.ZoomToSelection.prototype.doExecute = function( map )
{
	var layers = map.getSelectedLayers();

	if( layers && layers.length > 0 )
	{
		var extents = [];
		for( var i=0; i<layers.length; i++ )
		{
			layers[i].getExtent( function( result ) {
				extents.push( result.extent );
				if( extents.length === layers.length )
				{
					map.fitExtent( gc.gis.GCUtil.mergeExtents( extents ) );
				}
			});
		}
	}
	else
	{
		gc.gis.iface.log.warn( this, 'Keine Ebenen ausgewählt!');
		//throw new gc.gis.error.GCError('Nothing selected');
	}
};

